import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

export type PostDrawCampaignParams = {
  lotteryEventBranchId: number;
  serialCode: string;
};

export type PostDrawCampaignResponse = APIResponse<{
  lotteryDrawHistoryId: number;
}>;

export const postDrawLotsFromCampaignV2 = async (params: PostDrawCampaignParams) => {
  return await http<PostDrawCampaignResponse>('/user/v2/lottery-draw-lots-from-campaign', {
    method: 'POST',
    body: JSON.stringify({
      lottery_event_branch_id: params.lotteryEventBranchId,
      serial_code: String(params.serialCode).toLocaleUpperCase(),
    }),
  });
};
